import { List, LayoutGrid } from "lucide-react";

export default function ViewToggle({ viewMode, setViewMode, imageSize, setImageSize }) {
  return (
    <div className="flex items-center gap-4">
      {viewMode === "grid" && (
        <div className="flex items-center gap-2">
          <span className="text-xs text-gray-500">Size:</span>
          <input
            type="range"
            min="1"
            max="4"
            value={imageSize}
            onChange={(e) => setImageSize(Number(e.target.value))}
            className="w-20 h-1 bg-gray-300 rounded-lg appearance-none cursor-pointer"
          />
        </div>
      )}
      <div className="flex border border-gray-200">
        <button
          onClick={() => setViewMode("list")}
          className={`p-2 ${viewMode === "list" ? "bg-black text-white" : "bg-white text-gray-600 hover:bg-gray-50"}`}
          title="List view"
        >
          <List size={18} />
        </button>
        <button
          onClick={() => setViewMode("grid")}
          className={`p-2 ${viewMode === "grid" ? "bg-black text-white" : "bg-white text-gray-600 hover:bg-gray-50"}`}
          title="Grid view"
        >
          <LayoutGrid size={18} />
        </button>
      </div>
    </div>
  );
}

export function gridCols(imageSize) {
  if (imageSize === 1) return "grid-cols-4 md:grid-cols-6 lg:grid-cols-8";
  if (imageSize === 2) return "grid-cols-3 md:grid-cols-5 lg:grid-cols-6";
  if (imageSize === 3) return "grid-cols-2 md:grid-cols-3 lg:grid-cols-4";
  return "grid-cols-1 md:grid-cols-2 lg:grid-cols-3";
}
